// https://github.com/nathanreyes/v-calendar
import { setupCalendar, Calendar, DatePicker } from "v-calendar";
import "v-calendar/style.css";
import "./styles/v-calendar.scss";

/**
 * Configure the app with a pre-configured v-calendar instance
 * [v-calendar]{ @link https://github.com/nathanreyes/v-calendar }
 * @param {Vue} VueInstance
 * @param {Object} config - v-calendar configuration (will override defaultConfig)
 */
export default function configureVCalendar(VueInstance) {
  // register components with consistent names
  VueInstance.use(setupCalendar, {});

  VueInstance.component("VCalendar", Calendar);
  VueInstance.component("VDatePicker", DatePicker);
}
